import React, { Fragment, useEffect, useState, useMemo, useCallback } from "react";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledTooltip, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import { Link } from "react-router-dom";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import { isEmpty } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";

import Flatpickr from "react-flatpickr";
import Select from "react-select";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { setClientSelect, setCompanySelect, setBranchSelect } from "../../../store/app/action";
import { getNominatif as onGetNominatif, addNewNominatif as onAddNewNominatif, updateNominatif as onUpdateNominatif, deleteNominatif as onDeleteNominatif, resetNominatifState } from "../../../store/actions";

import ExportCSVModal from "../../../Components/Common/ExportCSVModal";
import ExportDoc from "../../../Components/Common/ExportDoc";
import TableComponent from "../../../Components/TableComponent";
import { useRef } from "react";

const statusActiveData = [
  {
    options: [
      { label: "DRAFT", value: "1" },
      { label: "ACTIVE", value: "2" },
      { label: "INACTIVE", value: "3" },
    ],
  },
];

const initialValueFormik = {
  id: null,
  client: null,
  company: null,
  branch: null,
  nama: "",
  tempat_lahir: "",
  tgl_lahir: "",
  usia: "",
  pekerjaan: null,
  ktp: "",
  alamat_1: "",
  kota_pemilik: "",
  luas_tanah: "",
  kelas_desa: "",
  terbilang_luas_tanah: "",
  no_c: "",
  no_persil: "",
  blok: "",
  nop: "",
  harga: "",
  terbilang_harga: "",
  letak_tanah: "",
  desa: "",
  kecamatan: "",
  kabupaten: "",
  nama_pasangan: "",
  tanggal_lhr_pasangan: "",
  tempat_lhr_pasangan: "",
  pekerjaan_pasangan: "",
  alamat_pasangan: "",
  ktp_pasangan: "",
  tempat: "",
  tgl: "",
  rt: "",
  rw: "",
  ketua_rt: "",
  ketua_rw: "",
  kadus: "",
  sekdes: "",
  kepala_desa: "",
  utara: "",
  timur: "",
  selatan: "",
  barat: "",
  tahun_1: "",
  ats_nama_1: "",
  berdasarkan_1: "",
  tahun_2: "",
  beralih_kepada_2: "",
  berdasarkan_2: "",
  tahun_3: "",
  beralih_kepada_3: "",
  berdasarkan_3: "",
  tahun_4: "",
  beralih_kepada_4: "",
  berdasarkan_4: "",
  kota_1: "",
  kota_2: "",
  kota_3: "",
  kota_4: "",
  saksi_sk_1: "",
  umur_sk_1: "",
  pekerjaan_sk_1: "",
  alamat_sk_1: "",
  saksi_sk_2: "",
  umur_sk_2: "",
  pekerjaan_sk_2: "",
  alamat_sk_2: "",
  nama_2: "",
  usia_2: "",
  pekerjaan_2: "",
  alamat_2: "",
  no_sph: "",
  warga_negara: "",
  alih_2: "",
  saksi_st_1: "",
  njop: "",
  dasar: "",
  jenis: "",
};

const Nominatif = () => {
  const prevLoadingActionPost = useRef(null);
  const dataDelete = useRef(null);
  const [modal, setModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [activeTypeTab, setActiveTypeTab] = useState("all");
  const [pageIdx, setPageIdx] = useState(0);
  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, loading, loadingAction, nominatifs, clientLoading, clients, companyLoading, companies, branchLoading, branches } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    //nominatif
    loading: state.Nominatif.loading,
    loadingAction: state.Nominatif.loadingAction,
    nominatifs: state.Nominatif.nominatifs,
    count: state.Nominatif.count,
    offset: state.Nominatif.offset,
    limit: state.Nominatif.limit,
    isNominatifCreated: state.Nominatif.isNominatifCreated,
    isNominatifSuccess: state.Nominatif.isNominatifSuccess,
    error: state.Nominatif.error,
    //client
    clientLoading: state.Client.loading,
    clients: state.Client.clients,
    //company
    companyLoading: state.Company.loading,
    companies: state.Company.companies,
    //branch
    branchLoading: state.Branch.loading,
    branches: state.Branch.branches,
  }));

  const [nominatifDataList, setNominatifDataList] = useState([]);
  const [printDoc, setPrintDoc] = useState([]);
  const [nominatif, setNominatif] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [branchList, setBranchList] = useState([]);

  const [isEdit, setIsEdit] = useState(false);

  const [searchValue, setSearchValue] = useState([]);

  const onClickDelete = (nominatif) => {
    dataDelete.current = nominatif;
    setDeleteModal(true);
  };

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      const { client, company, branch } = validationNom.values;
      validationNom.resetForm({
        values: {
          ...validationNom.initialValues,
          client,
          company,
          branch,
        },
      });
    } else {
      setModal(true);
      // validationNom.resetForm();
    }
  }, [modal]);

  function numberToWords(input) {
    const number = Number(input);

    if (isNaN(number)) {
      return "Input harus angka yang valid (contoh: 6500000 atau '6500000')";
    }

    if (number < 0) {
      return "Input harus non-negatif";
    }

    const num = Math.floor(number);

    if (num === 0) {
      return "Nol Rupiah";
    }

    const satuan = ["", "Satu", "Dua", "Tiga", "Empat", "Lima", "Enam", "Tujuh", "Delapan", "Sembilan"];
    const belasan = ["Sepuluh", "Sebelas", "Dua Belas", "Tiga Belas", "Empat Belas", "Lima Belas", "Enam Belas", "Tujuh Belas", "Delapan Belas", "Sembilan Belas"];
    const puluhan = ["", "", "Dua Puluh", "Tiga Puluh", "Empat Puluh", "Lima Puluh", "Enam Puluh", "Tujuh Puluh", "Delapan Puluh", "Sembilan Puluh"];
    const skala = ["", "Ribu", "Juta", "Miliar", "Triliun", "Kuadriliun", "Kuintiliun"];

    function convertLessThanThousand(n) {
      if (n === 0) return "";
      if (n < 10) return satuan[n];
      if (n < 20) return belasan[n - 10];
      if (n < 100) {
        const p = puluhan[Math.floor(n / 10)];
        const s = satuan[n % 10];
        return p + (s ? " " + s : "");
      }
      const ratus = satuan[Math.floor(n / 100)];
      const sisa = n % 100;
      let hasil = ratus + " Ratus";
      if (sisa > 0) hasil += " " + convertLessThanThousand(sisa);
      return hasil;
    }

    let parts = [];
    let temp = num;
    while (temp > 0) {
      parts.push(temp % 1000);
      temp = Math.floor(temp / 1000);
    }

    let result = [];
    for (let i = parts.length - 1; i >= 0; i--) {
      const val = parts[i];
      if (val === 0) continue;

      let chunk = convertLessThanThousand(val);
      if (i > 0) {
        chunk += " " + skala[i];
      }
      if (chunk) result.push(chunk);
    }

    let final = result.join(" ");

    final = final.replace(/^Satu Ribu\b/, "Seribu");

    final = final.replace(/Satu Ratus(?=.*(Juta|Miliar|Triliun|Kuadriliun|Kuintiliun))/g, "Seratus");

    return final + " Rupiah";
  }

  function numberToWordOnly(input) {
    const number = Number(input);

    if (isNaN(number)) {
      return "Input harus angka yang valid (contoh: 6500000 atau '6500000')";
    }

    if (number < 0) {
      return "Input harus non-negatif";
    }

    const num = Math.floor(number);

    if (num === 0) {
      return "";
    }

    const satuan = ["", "Satu", "Dua", "Tiga", "Empat", "Lima", "Enam", "Tujuh", "Delapan", "Sembilan"];
    const belasan = ["Sepuluh", "Sebelas", "Dua Belas", "Tiga Belas", "Empat Belas", "Lima Belas", "Enam Belas", "Tujuh Belas", "Delapan Belas", "Sembilan Belas"];
    const puluhan = ["", "", "Dua Puluh", "Tiga Puluh", "Empat Puluh", "Lima Puluh", "Enam Puluh", "Tujuh Puluh", "Delapan Puluh", "Sembilan Puluh"];
    const skala = ["", "Ribu", "Juta", "Miliar", "Triliun", "Kuadriliun", "Kuintiliun"];

    function convertLessThanThousand(n) {
      if (n === 0) return "";
      if (n < 10) return satuan[n];
      if (n < 20) return belasan[n - 10];
      if (n < 100) {
        const p = puluhan[Math.floor(n / 10)];
        const s = satuan[n % 10];
        return p + (s ? " " + s : "");
      }
      const ratus = satuan[Math.floor(n / 100)];
      const sisa = n % 100;
      let hasil = ratus + " Ratus";
      if (sisa > 0) hasil += " " + convertLessThanThousand(sisa);
      return hasil;
    }

    let parts = [];
    let temp = num;
    while (temp > 0) {
      parts.push(temp % 1000);
      temp = Math.floor(temp / 1000);
    }

    let result = [];
    for (let i = parts.length - 1; i >= 0; i--) {
      const val = parts[i];
      if (val === 0) continue;

      let chunk = convertLessThanThousand(val);
      if (i > 0) {
        chunk += " " + skala[i];
      }
      if (chunk) result.push(chunk);
    }

    let final = result.join(" ");

    final = final.replace(/^Satu Ribu\b/, "Seribu");

    final = final.replace(/Satu Ratus(?=.*(Juta|Miliar|Triliun|Kuadriliun|Kuintiliun))/g, "Seratus");

    return final;
  }

  const pekerjaanData = [
    {
      options: [
        { label: "WIRASWASTA", value: "WIRASWASTA" },
        { label: "KARYAWAN SWASTA", value: "KARYAWAN SWASTA" },
        { label: "DOKTER", value: "DOKTER" },
        { label: "APARATUR SIPIL NEGARA", value: "APARATUR SIPIL NEGARA" },
        { label: "TENTARA NASIONAL INDONESIA", value: "TENTARA NASIONAL INDONESIA " },
        { label: "POLRI", value: "POLRI" },
        { label: "KARYAWAN BUMN", value: "KARYAWAN BUMN" },
        { label: "KARYAWAN BUMD", value: "KARYAWAN BUMD" },
        { label: "KARYAWAN HONORER", value: "KARYAWAN HONORER" },
        { label: "BURUH HARIAN LEPAS", value: "BURUH HARIAN LEPAS" },
        { label: "PENSIUNAN", value: "PENSIUNAN" },
        { label: "IBU RUMAH TANGGA", value: "IBU RUMAH TANGGA" },
        { label: "BELUM BEKERJA", value: "BELUM BEKERJA" },
        { label: "PELAJAR / MAHASISWA", value: "PELAJAR / MAHASISWA" },
        { label: "LAIN-LAIN", value: "LAIN-LAIN" },
        { label: "NOTARIS", value: "NOTARIS" },
        { label: "DIKOSONGKAN", value: "" },
      ],
    },
  ];

  const blankocData = [
    {
      options: [
        { label: "SAWAH", value: "SAWAH" },
        { label: "DARAT", value: "DARAT" },
      ],
    },
  ];
  
  const handleNominatifClick = useCallback((row, isCopy) => {
    const data = row;

    validationNom.setValues({
      id: data.id || null,
      nama: data.nama,
      tempat_lahir: data.tempat_lahir,
      tgl_lahir: data.tgl_lahir,
      usia: data.usia,
      pekerjaan: data.pekerjaan ? { value: data.pekerjaan, label: data.pekerjaan } : null,
      blankoc: data.blankoc ? { value: data.blankoc, label: data.blankoc } : null,
      ktp: data.ktp,
      alamat_1: data.alamat_1,
      kota_pemilik: data.kota_pemilik,
      luas_tanah: data.luas_tanah,
      kelas_desa: data.kelas_desa,
      terbilang_luas_tanah: numberToWordOnly(parseFloat(data.luas_tanah), "Meter Persegi"),
      no_c: data.no_c,
      no_persil: data.no_persil,
      blok: data.blok,
      nop: data.nop,
      harga: data.harga,
      terbilang_harga: numberToWords(parseFloat(data.harga), "Rupiah"),
      letak_tanah: data.letak_tanah,
      desa: data.desa,
      kecamatan: data.kecamatan,
      kabupaten: data.kabupaten,
      nama_pasangan: data.nama_pasangan,
      tanggal_lhr_pasangan: data.tanggal_lhr_pasangan,
      tempat_lhr_pasangan: data.tempat_lhr_pasangan,
      pekerjaan_pasangan: data.pekerjaan_pasangan,
      alamat_pasangan: data.alamat_pasangan,
      ktp_pasangan: data.ktp_pasangan,
      tempat: data.tempat,
      tgl: data.tgl,
      rt: data.rt,
      rw: data.rw,
      ketua_rt: data.ketua_rt,
      ketua_rw: data.ketua_rw,
      kadus: data.kadus,
      sekdes: data.sekdes,
      kepala_desa: data.kepala_desa,
      utara: data.utara,
      timur: data.timur,
      selatan: data.selatan,
      barat: data.barat,
      tahun_1: data.tahun_1,
      ats_nama_1: data.ats_nama_1,
      tahun_2: data.tahun_2,
      beralih_kepada_2: data.beralih_kepada_2,
      berdasarkan_1: data.berdasarkan_1,
      berdasarkan_2: data.berdasarkan_2,
      tahun_3: data.tahun_3,
      beralih_kepada_3: data.beralih_kepada_3,
      berdasarkan_3: data.berdasarkan_3,
      tahun_4: data.tahun_4,
      beralih_kepada_4: data.beralih_kepada_4,
      berdasarkan_4: data.berdasarkan_4,
      kota_1: data.kota_1,
      kota_2: data.kota_2,
      kota_3: data.kota_3,
      kota_4: data.kota_4,
      saksi_sk_1: data.saksi_sk_1,
      umur_sk_1: data.umur_sk_1,
      pekerjaan_sk_1: data.pekerjaan_sk_1,
      alamat_sk_1: data.alamat_sk_1,
      saksi_sk_2: data.saksi_sk_2,
      umur_sk_2: data.umur_sk_2,
      pekerjaan_sk_2: data.pekerjaan_sk_2,
      alamat_sk_2: data.alamat_sk_2,
      nama_2: data.nama_2,
      usia_2: data.usia_2,
      pekerjaan_2: data.pekerjaan_2,
      alamat_2: data.alamat_2,
      warga_negara: data.warga_negara,
      alih_2: data.alih_2,
      saksi_st_1: data.saksi_st_1,
      njop: data.njop,
      dasar: data.dasar,
      jenis: data.jenis,
      no_sph: data.no_sph,
      no_ijin_lksi: data.no_ijin_lksi,
    });

    setIsEdit(isCopy);
    toggle();
  }, []);

  const validationSchema = (context) =>
    Yup.object({
      nama: Yup.string().required("Nama is required"),
    });

  const validationNom = useFormik({
    enableReinitialize: true,
    initialValues: initialValueFormik,
    validationSchema: validationSchema(),
    onSubmit: (values) => {
      const { id, pekerjaan, blankoc, ...tranformValue } = values;
      const dataForm = {
        clientId: clientSelected.value ?? null,
        companyId: companySelected.value ?? null,
        branchId: branchSelected.value ?? null,
        pekerjaan: values.pekerjaan?.value ?? null,
        blankoc: values.blankoc?.value ?? null,
        ...tranformValue,
      };

      if (isEdit) dataForm.id = values.id;

      const action = isEdit ? onUpdateNominatif : onAddNewNominatif;

      dispatch(action(dataForm));
      toggle();
    },
  });

  const [isCheckAll, setIsCheckAll] = useState(false);
  const rowsRef = useRef([]);
  const checkedAll = () => {
    const allChecked = rowsRef.current.every((item) => item?.isChecked);
    const visibleIds = rowsRef.current.map((r) => String(r.id));

    const updated = nominatifDataList.map((item) => {
      const isVisible = visibleIds.includes(String(item.id));
      return isVisible ? { ...item, isChecked: !allChecked } : item;
    });
    setNominatifDataList(updated);
    setIsCheckAll(allChecked);
  };

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  const columns = useMemo(
    () => [
      {
        Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={isCheckAll} onChange={checkedAll} />,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              <input
                type="checkbox"
                className="dataCheckbox me-2 form-check-input"
                checked={data.isChecked}
                onChange={() => {
                  const updatedData = nominatifDataList.map((d) => (d.id === data.id ? { ...d, isChecked: !d.isChecked } : d));
                  setNominatifDataList(updatedData);
                }}
              />
              <ButtonGroup className="me-1">
                <UncontrolledButtonDropdown>
                  <Button
                    color="light"
                    className="btn-sm"
                    onClick={() => {
                      const nominatifData = cellProps.row.original;
                      handleNominatifClick(nominatifData, true);
                    }}
                  >
                    <i className="ri-edit-2-line fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className="btn-sm"
                    onClick={() => {
                      const nominatifData = cellProps.row.original;
                      handleNominatifClick(nominatifData, false);
                    }}
                  >
                    <i className="ri-file-copy-line fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("updateLegal") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      const nominatifData = cellProps.row.original;
                      onClickDelete(nominatifData);
                    }}
                  >
                    <i className="ri-delete-bin-line fs-15"></i>
                  </Button>
                </UncontrolledButtonDropdown>
              </ButtonGroup>
            </div>
          );
        },
        id: "#",
      },
      {
        Header: "Nama",
        accessor: "nama",
        filterable: true,
      },
      {
        Header: "No C",
        accessor: "no_c",
        filterable: true,
      },
      {
        Header: "Kota Pemilik",
        accessor: "kota_pemilik",
        filterable: true,
      },
      {
        Header: "Luas Tanah",
        accessor: "luas_tanah",
        filterable: true,
        Cell: (data) => {
          return <span>{currencyFormat(data.row.original.luas_tanah === null ? 0 : data.row.original.luas_tanah)}</span>;
        },
      },
      {
        id: "Harga",
        Header: "Harga",
        accessor: "harga",
        filterable: true,
        Cell: (data) => {
          return <span>{currencyFormat(data.row.original.harga === null ? 0 : data.row.original.harga)}</span>;
        },
      },
      {
        Header: "Perusahaan",
        accessor: "nominatif_company.name",
        filterable: true,
      },
      {
        Header: "Status",
        accessor: "nominatif_status.name",
        filterable: true,
        Cell: (cell) => {
          switch (cell.value) {
            case "DRAFT":
              return <span className="badge text-uppercase badge-soft-warning"> {cell.value} </span>;
            case "ACTIVE":
              return <span className="badge text-uppercase badge-soft-info"> {cell.value} </span>;
            case "INACTIVE":
              return <span className="badge text-uppercase badge-soft-danger"> {cell.value} </span>;
            default:
              return <span className="badge text-uppercase badge-soft-warning"> {cell.value} </span>;
          }
        },
      },
    ],
    [nominatifDataList, isCheckAll],
  );

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onChange = useAsyncDebounce((value) => {
    const resetChecked = nominatifDataList.map((item) => ({
      ...item,
      isChecked: false,
    }));
    setNominatifDataList(resetChecked);
    setIsCheckAll(false);
    setGlobalFilter(value || undefined);
    setGlobalFilterValue(value ?? "");
  }, 300);

  const memoizedData = useMemo(() => nominatifDataList, [nominatifDataList]);

  //TABLE
  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: memoizedData,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: pageIdx,
        pageSize: 10,
        selectedRowIds: 0,
        globalFilter: globalFilterValue,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect,
  );

  useEffect(() => {
    const currentRows = rows.map((r) => r.original);
    rowsRef.current = currentRows;
    const allChecked = currentRows.length > 0 && currentRows.every((item) => item.isChecked);
    setIsCheckAll(allChecked);
  }, [rows]);

  const count = preGlobalFilteredRows.length;

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeTable = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 200);

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    setPageIdx(page);
    gotoPage(page);
  };

  function handleFilter() {
    const param = {
      title: searchValue,
    };
    dispatch(onGetNominatif(param));
  }

  const handleResetFilter = () => {
    setNominatifDataList([]);
    setSearchValue("");
    setGlobalFilter(undefined);
    setGlobalFilterValue("");
    handleFetchData(companySelected.value, branchSelected.value);
  };
  ///TABLE

  const handleDelete = () => {
    if (dataDelete.current) {
      dispatch(onDeleteNominatif(dataDelete.current));
    }
  };

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setActiveTypeTab(type);
      let filteredNominatifes = nominatifs;
      if (type !== "all") {
        filteredNominatifes = nominatifs.filter((nominatif) => nominatif.nominatif_status.name === type);
      }
      setNominatifDataList(filteredNominatifes);
    }
  };

  const handleFetchData = (companyId, branchId) => {
    dispatch(resetNominatifState());
    dispatch(onGetNominatif({ companyId: companyId, branchId: branchId }));
  };

  useEffect(() => {
    if (!isEmpty(nominatifs)) {
      let filteredNominatifes = nominatifs;
      if (activeTypeTab !== "all") {
        filteredNominatifes = nominatifs.filter((nominatif) => nominatif.nominatif_status.name === activeTypeTab);
      }

      setNominatifDataList(filteredNominatifes.map((el) => ({ ...el, isChecked: false })));
    } else {
      setNominatifDataList([]);
    }
  }, [nominatifs]);

  useEffect(() => {
    let dataDoc = [
      {
        id: "nominatif_client",
        label: "Grup Usaha",
        isSelected: true,
        data: [],
      },
      {
        id: "nominatif_company",
        label: "Perusahaan",
        isSelected: true,
        data: [],
      },
      {
        id: "nominatif_branch",
        label: "Proyek",
        isSelected: true,
        data: [],
      },
      {
        id: "nama",
        label: "Nama",
        isSelected: true,
        data: [],
      },
      {
        id: "tempat_lahir",
        label: "Tempat Lahir",
        isSelected: true,
        data: [],
      },
      {
        id: "tgl_lahir",
        label: "Tanggal Lahir",
        isSelected: true,
        data: [],
      },
      {
        id: "usia",
        label: "Usia",
        isSelected: true,
        data: [],
      },
      {
        id: "pekerjaan",
        label: "Pekerjaan",
        isSelected: true,
        data: [],
      },
      {
        id: "ktp",
        label: "No. KTP",
        isSelected: true,
        data: [],
      },
      {
        id: "alamat_1",
        label: "Alamat",
        isSelected: true,
        data: [],
      },
      {
        id: "kota_pemilik",
        label: "Kota Pemilik",
        isSelected: true,
        data: [],
      },
      {
        id: "luas_tanah",
        label: "Luas Tanah",
        isSelected: true,
        data: [],
      },
      {
        id: "kelas_desa",
        label: "Kelas Desa",
        isSelected: true,
        data: [],
      },
      {
        id: "terbilang_luas_tanah",
        label: "Terbilang Luas Tanah",
        isSelected: true,
        data: [],
      },
      {
        id: "no_c",
        label: "No. C",
        isSelected: true,
        data: [],
      },
      {
        id: "no_persil",
        label: "No. Persil",
        isSelected: true,
        data: [],
      },
      {
        id: "blok",
        label: "Blok",
        isSelected: true,
        data: [],
      },
      {
        id: "nop",
        label: "NOP",
        isSelected: true,
        data: [],
      },
      {
        id: "harga",
        label: "Harga",
        isSelected: true,
        data: [],
      },
      {
        id: "terbilang_harga",
        label: "Terbilang Harga",
        isSelected: true,
        data: [],
      },
      {
        id: "letak_tanah",
        label: "Letak Tanah",
        isSelected: true,
        data: [],
      },
      {
        id: "desa",
        label: "Desa",
        isSelected: true,
        data: [],
      },
      {
        id: "kecamatan",
        label: "Kecamatan",
        isSelected: true,
        data: [],
      },
      {
        id: "tempat",
        label: "Tempat",
        isSelected: true,
        data: [],
      },
      {
        id: "tgl",
        label: "Tanggal",
        isSelected: true,
        data: [],
      },
      {
        id: "rt",
        label: "RT",
        isSelected: true,
        data: [],
      },
      {
        id: "rw",
        label: "RW",
        isSelected: true,
        data: [],
      },
      {
        id: "ketua_rt",
        label: "Ketua RT",
        isSelected: true,
        data: [],
      },
      {
        id: "ketua_rw",
        label: "Ketua RW",
        isSelected: true,
        data: [],
      },
      {
        id: "kadus",
        label: "Kadus",
        isSelected: true,
        data: [],
      },
      {
        id: "sekdes",
        label: "Sekdes",
        isSelected: true,
        data: [],
      },
      {
        id: "kepala_desa",
        label: "Kepala Desa",
        isSelected: true,
        data: [],
      },
      {
        id: "utara",
        label: "Batas Utara",
        isSelected: true,
        data: [],
      },
      {
        id: "timur",
        label: "Batas Timur",
        isSelected: true,
        data: [],
      },
      {
        id: "selatan",
        label: "Batas Selatan",
        isSelected: true,
        data: [],
      },
      {
        id: "barat",
        label: "Batas Barat",
        isSelected: true,
        data: [],
      },
      {
        id: "tahun_1",
        label: "Tahun 1",
        isSelected: true,
        data: [],
      },
      {
        id: "ats_nama_1",
        label: "Atas Nama 1",
        isSelected: true,
        data: [],
      },
      {
        id: "tahun_2",
        label: "Tahun 2",
        isSelected: true,
        data: [],
      },
      {
        id: "beralih_kepada_2",
        label: "Beralih Kepada 2",
        isSelected: true,
        data: [],
      },
      {
        id: "berdasarkan_1",
        label: "Berdasarkan 1",
        isSelected: true,
        data: [],
      },
      {
        id: "berdasarkan_2",
        label: "Berdasarkan 2",
        isSelected: true,
        data: [],
      },
      {
        id: "tahun_3",
        label: "Tahun 3",
        isSelected: true,
        data: [],
      },
      {
        id: "beralih_kepada_3",
        label: "Beralih Kepada 3",
        isSelected: true,
        data: [],
      },
      {
        id: "berdasarkan_3",
        label: "Berdasarkan 3",
        isSelected: true,
        data: [],
      },
      {
        id: "tahun_4",
        label: "Tahun 4",
        isSelected: true,
        data: [],
      },
      {
        id: "beralih_kepada_4",
        label: "Beralih Kepada 4",
        isSelected: true,
        data: [],
      },
      {
        id: "berdasarkan_4",
        label: "Berdasarkan 4",
        isSelected: true,
        data: [],
      },
      {
        id: "saksi_sk_1",
        label: "Saksi SK 1",
        isSelected: true,
        data: [],
      },
      {
        id: "umur_sk_1",
        label: "Umur SK 1",
        isSelected: true,
        data: [],
      },
      {
        id: "pekerjaan_sk_1",
        label: "Pekerjaan SK 1",
        isSelected: true,
        data: [],
      },
      {
        id: "alamat_sk_1",
        label: "Alamat SK 1",
        isSelected: true,
        data: [],
      },
      {
        id: "saksi_sk_2",
        label: "Saksi SK 2",
        isSelected: true,
        data: [],
      },
      {
        id: "umur_sk_2",
        label: "Umur SK 2",
        isSelected: true,
        data: [],
      },
      {
        id: "pekerjaan_sk_2",
        label: "Pekerjaan SK 2",
        isSelected: true,
        data: [],
      },
      {
        id: "alamat_sk_2",
        label: "Alamat SK 2",
        isSelected: true,
        data: [],
      },
      {
        id: "nama_2",
        label: "Nama 2",
        isSelected: true,
        data: [],
      },
      {
        id: "usia_2",
        label: "Usia 2",
        isSelected: true,
        data: [],
      },
      {
        id: "pekerjaan_2",
        label: "Pekerjaan 2",
        isSelected: true,
        data: [],
      },
      {
        id: "alamat_2",
        label: "Alamat 2",
        isSelected: true,
        data: [],
      },
      {
        id: "no_sph",
        label: "No. SPH",
        isSelected: true,
        data: [],
      },
      {
        id: "no_ijin_lksi",
        label: "No. Ijin Lokasi",
        isSelected: true,
        data: [],
      },
      {
        id: "warga_negara",
        label: "Warga negara",
        isSelected: true,
        data: [],
      },
      {
        id: "alih_2",
        label: "Peralihan",
        isSelected: true,
        data: [],
      },
      {
        id: "saksi_st_1",
        label: "Saksi Sertifikat 1",
        isSelected: true,
        data: [],
      },
      {
        id: "njop",
        label: "NJOP",
        isSelected: true,
        data: [],
      },
      {
        id: "jenis",
        label: "Jenis",
        isSelected: true,
        data: [],
      },
      {
        id: "dasar",
        label: "Dasar",
        isSelected: true,
        data: [],
      },
      {
        id: "kabupaten",
        label: "Kabupaten",
        isSelected: true,
        data: [],
      },
      {
        id: "nama_pasangan",
        label: "nama_pasangan",
        isSelected: true,
        data: [],
      },
      {
        id: "tanggal_lhr_pasangan",
        label: "tanggal_lhr_pasangan",
        isSelected: true,
        data: [],
      },
      {
        id: "tempat_lhr_pasangan",
        label: "tempat_lhr_pasangan",
        isSelected: true,
        data: [],
      },
      {
        id: "pekerjaan_pasangan",
        label: "pekerjaan_pasangan",
        isSelected: true,
        data: [],
      },
      {
        id: "alamat_pasangan",
        label: "alamat_pasangan",
        isSelected: true,
        data: [],
      },
      {
        id: "ktp_pasangan",
        label: "ktp_pasangan",
        isSelected: true,
        data: [],
      },
    ];

    if (nominatifDataList.length > 0) {
      nominatifDataList.forEach((data) => {
        if (data.isChecked) {
          Object.entries(data).forEach(([key, value]) => {
            const doc = dataDoc.find((d) => d.id === key);
            if (doc) {
              if (doc.id === "nominatif_client" || doc.id === "nominatif_company" || doc.id === "nominatif_branch") {
                doc.data.push(value?.name ?? "-");
              } else {
                doc.data.push(value ?? "-");
              }
            }
          });
        }
      });
    }

    setPrintDoc(dataDoc);
  }, [nominatifDataList]);

  useEffect(() => {
    handleFetchData(companySelected.value, branchSelected.value);
  }, [companySelected, branchSelected]);

  //handle side add
  useEffect(() => {
    const wasLoading = prevLoadingActionPost.current === true;
    const isNowNotLoading = loadingAction === false;

    //modal
    if (modal && wasLoading && isNowNotLoading) {
      toggle();
    }

    if (modal) {
      prevLoadingActionPost.current = loadingAction;
    } else {
      prevLoadingActionPost.current = null;
    }

    //delete
    if (deleteModal && wasLoading && isNowNotLoading) {
      dataDelete.current = null;
      setDeleteModal(false);
    }

    if (deleteModal) {
      prevLoadingActionPost.current = loadingAction;
    } else {
      prevLoadingActionPost.current = null;
    }
  }, [loadingAction, modal, deleteModal]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  useEffect(() => {
    var data = [];
    var opt = [];
    (companies || []).forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (companies.length > 0) {
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    var data = [];
    var opt = [];
    (branches || []).forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (branches.length > 0) {
      setBranchList(data);
    }
  }, [branches]);

  document.title = "Nominatif | PESONA KAHURIPAN";
  return (
    <div className="page-content">
      <DeleteModal show={deleteModal} onDeleteClick={handleDelete} onCloseClick={() => setDeleteModal(false)} />
      <Container fluid>
        <BreadCrumb title="Pertanahan" pageTitle="Nominatif" loading={loading}>
          <div className="flex-shrink-0">
            <button
              type="button"
              className={"btn btn-primary add-btn me-2"}
              id="create-btn"
              onClick={() => {
                setIsEdit(false);
                toggle();
              }}
            >
              <i className="ri-booklet-line me-1 align-bottom fs-14"></i> Tambah
            </button>
            <ExportDoc data={printDoc} />
            {/* <button
              className={userType === "admin" || userType === "client" || userType === "company" ? "btn ms-1 btn-soft-danger" : userRole && userRole.split(",").indexOf("deleteNominatif") !== -1 ? "btn ms-1 btn-soft-danger" : "btn ms-1 btn-soft-danger d-none"}
              onClick={() => {
                // setDeleteModalMulti(true);
              }}>
              <i className="ri-delete-bin-5-line me-1 align-bottom fs-15"></i> Delete
            </button> */}
          </div>
        </BreadCrumb>
        <Row>
          <Col lg={12}>
            <Card id="nominatifDataList">
              <CardBody className="pt-1">
                <div>
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href="#"
                      >
                        <i className="ri-booklet-line me-1 align-bottom fs-14"></i> ALL CATEGORY
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "2" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("2", "DRAFT");
                        }}
                        href="#"
                      >
                        <i className="ri-information-line me-1 align-bottom fs-14"></i> DRAFT
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "3" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("3", "ACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> ACTIVE
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "4" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("4", "INACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-indeterminate-circle-line me-1 align-bottom fs-14"></i> INACTIVE
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={2}>
                            <div className="me-2 mb-2 col-12">
                              <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={8}>
                            <div className="search-box me-2 mb-2 d-inline-block col-12">
                              <input
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                                  gotoPage(0);
                                }}
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                placeholder={`${count} Cari...`}
                                value={searchValue ?? ""}
                              />
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={2}>
                            <div className="hstack gap-2">
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleFilter();
                                }}
                              >
                                <i className="ri-search-line align-bottom fs-16"></i>
                              </button>
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleResetFilter();
                                }}
                              >
                                <i className="mdi mdi-restore align-bottom fs-18"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>

                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>

                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button
                          className="btn btn-light"
                          onClick={() => {
                            setPageIdx(pageIndex - 1);
                            previousPage();
                          }}
                          disabled={!canPreviousPage}
                        >
                          {" "}
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button
                          className="btn btn-light"
                          onClick={() => {
                            setPageIdx(pageIndex + 1);
                            nextPage();
                          }}
                          disabled={!canNextPage}
                        >
                          {" "}
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      <Modal id="showModal" isOpen={modal} centered size="xl">
        <ModalHeader className="bg-light p-3" toggle={toggle}>
          {!!isEdit ? "EDIT DATA NOMINATIF" : "TAMBAH DATA NOMINATIF"}
        </ModalHeader>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            validationNom.handleSubmit();
            return false;
          }}
        >
          <ModalBody>
            <div className="row border-bottom mb-1 pb-2">
              <h5 className="mb-3 bg-soft-info p-2 pb-3">Data Diri Pemilik</h5>
              <div className="mb-3 col-lg-3 d-none">
                <Label htmlFor="client-field" className="form-label">
                  Grup Usaha&nbsp;
                  {clientLoading && (
                    <Spinner color="primary" size="sm">
                      Loading...
                    </Spinner>
                  )}
                </Label>
                <Select
                  name="client"
                  value={validationNom.values.client}
                  isDisabled={userType === "admin" || userType === "client" ? false : true}
                  placeholder="Pilih Grup Usaha"
                  onChange={(e) => {
                    dispatch(setClientSelect(e));
                    validationNom.setFieldValue("company", null);
                    validationNom.setFieldValue("client", e);
                  }}
                  options={clientList}
                ></Select>
              </div>
              <div className="mb-3 col-lg-3 d-none">
                <Label htmlFor="company-field" className="form-label">
                  Perusahaan&nbsp;
                  {companyLoading && (
                    <Spinner color="primary" size="sm">
                      Loading...
                    </Spinner>
                  )}
                </Label>
                <Select
                  name="company"
                  value={validationNom.values.company}
                  placeholder="Pilih Perusahaan"
                  isDisabled={userType === "admin" || userType === "client" ? false : true}
                  onChange={(e) => {
                    dispatch(setCompanySelect(e));
                    validationNom.setFieldValue("branch", null);
                    validationNom.setFieldValue("company", e);
                  }}
                  options={companyList}
                ></Select>
              </div>
              <div className="mb-3 col-lg-3 d-none">
                <Label htmlFor="company-field" className="form-label">
                  Cabang / Proyek&nbsp;
                  {companyLoading && (
                    <Spinner color="primary" size="sm">
                      Loading...
                    </Spinner>
                  )}
                </Label>
                <Select
                  name="branch"
                  value={validationNom.values.branch}
                  placeholder="Pilih Perusahaan"
                  onChange={(e) => {
                    validationNom.setFieldValue("branch", e);
                  }}
                  options={branchList}
                ></Select>
              </div>
              <div className="mb-3 col-lg-3">
                <Label htmlFor="name-field" className="form-label">
                  Nama
                </Label>
                <Input
                  name="nama"
                  id="nama-field"
                  className="form-control"
                  placeholder="Isi Nama Pemilik"
                  type="text"
                  onChange={(e) => {
                    const val = e.target.value;
                    validationNom.setFieldValue("nama", val);
                  }}
                  value={validationNom.values.nama}
                  invalid={validationNom.touched.nama && validationNom.errors.nama ? true : false}
                />
                {validationNom.touched.nama && validationNom.errors.nama ? <FormFeedback type="invalid">{validationNom.errors.nama}</FormFeedback> : null}
              </div>
              <div className="mb-3 col-lg-3">
                <Label htmlFor="tempat_lahir-field" className="form-label">
                  Tempat Lahir
                </Label>
                <Input
                  name="tempat_lahir"
                  id="tempat_lahir-field"
                  className="form-control"
                  placeholder="Isi Tempat Lahir Pemilik"
                  type="text"
                  onChange={(e) => {
                    const val = e.target.value;
                    validationNom.setFieldValue("tempat_lahir", val);
                  }}
                  value={validationNom.values.tempat_lahir}
                  invalid={validationNom.touched.tempat_lahir && validationNom.errors.tempat_lahir ? true : false}
                />
                {validationNom.touched.tempat_lahir && validationNom.errors.tempat_lahir ? <FormFeedback type="invalid">{validationNom.errors.tempat_lahir}</FormFeedback> : null}
              </div>
              <div className="mb-3 col-lg-3">
                <Label htmlFor="tgl_lahir-field" className="form-label">
                  Tanggal Lahir
                </Label>
                <Flatpickr
                  className="form-control"
                  id="datepicker-tgl_lahir-input"
                  placeholder="Pilih Tanggal Lahir Pemilik"
                  options={{
                    mode: "single",
                    dateFormat: "Y/m/d",
                  }}
                  onChange={(selectedDates, dateStr) => {
                    validationNom.setFieldValue("tgl_lahir", dateStr);
                    validationNom.setFieldValue("usia", moment().diff(moment(dateStr, "YYYY/MM/DD"), "years"));
                  }}
                  value={validationNom.values.tgl_lahir}
                />
                {validationNom.touched.tgl_lahir && validationNom.errors.tgl_lahir ? (
                  <p className="text-danger" type="invalid">
                    {validationNom.errors.tgl_lahir}
                  </p>
                ) : null}
              </div>
              <div className="mb-3 col-lg-3">
                <Label htmlFor="usia-field" className="form-label">
                  Usia
                </Label>
                <Input
                  name="usia"
                  id="usia-field"
                  className="form-control"
                  placeholder="Isi Usia Pemilik"
                  type="text"
                  onChange={(e) => {
                    const val = e.target.value;
                    validationNom.setFieldValue("usia", val);
                  }}
                  value={validationNom.values.usia}
                  invalid={validationNom.touched.usia && validationNom.errors.usia ? true : false}
                />
                {validationNom.touched.usia && validationNom.errors.usia && <FormFeedback type="invalid">{validationNom.errors.usia}</FormFeedback>}
              </div>
              <div className="mb-3 col-lg-3">
                <Label htmlFor="pekerjaan-field" className="form-label">
                  Pekerjaan
                </Label>
                <Select
                  name="pekerjaan"
                  value={validationNom.values.pekerjaan}
                  placeholder="Pilih Pekerjaan"
                  onChange={(e) => {
                    validationNom.setFieldValue("pekerjaan", e);
                  }}
                  options={pekerjaanData}
                ></Select>
              </div>
              <div className="mb-3 col-lg-3">
                <Label htmlFor="ktp-field" className="form-label">
                  KTP
                </Label>
                <Input
                  name="ktp"
                  id="ktp-field"
                  className="form-control"
                  placeholder="Isi Nomor KTP"
                  type="text"
                  onChange={(e) => {
                    validationNom.setFieldValue("ktp", e.target.value);
                  }}
                  value={validationNom.values.ktp}
                  invalid={validationNom.touched.ktp && validationNom.errors.ktp ? true : false}
                />
                {validationNom.touched.ktp && validationNom.errors.ktp && <FormFeedback type="invalid">{validationNom.errors.ktp}</FormFeedback>}
              </div>
              <div className="mb-3 col-lg-3">
                <Label htmlFor="alamat_1-field" className="form-label">
                  Alamat 1
                </Label>
                <Input
                  name="alamat_1"
                  id="alamat_1-field"
                  className="form-control"
                  placeholder="Alamat 1"
                  type="text"
                  onChange={(e) => {
                    validationNom.setFieldValue("alamat_1", e.target.value);
                  }}
                  value={validationNom.values.alamat_1}
                  invalid={validationNom.touched.alamat_1 && validationNom.errors.alamat_1 ? true : false}
                />
                {validationNom.touched.alamat_1 && validationNom.errors.alamat_1 && <FormFeedback type="invalid">{validationNom.errors.alamat_1}</FormFeedback>}
              </div>
              <div className="mb-3 col-lg-3">
                <Label htmlFor="kota_pemilik-field" className="form-label">
                  Kota Pemilik
                </Label>
                <Input
                  name="kota_pemilik"
                  id="kota_pemilik-field"
                  className="form-control"
                  placeholder="Kota Pemilik"
                  type="text"
                  onChange={(e) => {
                    validationNom.setFieldValue("kota_pemilik", e.target.value);
                  }}
                  value={validationNom.values.kota_pemilik}
                  invalid={validationNom.touched.kota_pemilik && validationNom.errors.kota_pemilik ? true : false}
                />
                {validationNom.touched.kota_pemilik && validationNom.errors.kota_pemilik && <FormFeedback type="invalid">{validationNom.errors.kota_pemilik}</FormFeedback>}
              </div>
            </div>

            <div className="row border-bottom mb-1 pb-2">
              <h5 className="mb-3 bg-soft-info p-2 pb-3">Data Diri Pasangan</h5>
              <div className="mb-3 col-lg-3">
                <Label htmlFor="name-field" className="form-label">
                  Nama Pasangan
                </Label>
                <Input
                  name="nama_pasangan"
                  id="nama_pasangan-field"
                  className="form-control"
                  placeholder="Isi Nama Pasangan"
                  type="text"
                  onChange={(e) => {
                    const val = e.target.value;
                    validationNom.setFieldValue("nama_pasangan", val);
                  }}
                  value={validationNom.values.nama_pasangan}
                  invalid={validationNom.touched.nama_pasangan && validationNom.errors.nama_pasangan ? true : false}
                />
                {validationNom.touched.nama_pasangan && validationNom.errors.nama_pasangan ? <FormFeedback type="invalid">{validationNom.errors.nama_pasangan}</FormFeedback> : null}
              </div>
              <div className="mb-3 col-lg-3">
                <Label htmlFor="tempat_lhr_pasangan-field" className="form-label">
                  Tempat Lahir
                </Label>
                <Input
                  name="tempat_lhr_pasangan"
                  id="tempat_lhr_pasangan-field"
                  className="form-control"
                  placeholder="Isi Tempat Lahir Pasangan"
                  type="text"
                  onChange={(e) => {
                    const val = e.target.value;
                    validationNom.setFieldValue("tempat_lhr_pasangan", val);
                  }}
                  value={validationNom.values.tempat_lhr_pasangan}
                  invalid={validationNom.touched.tempat_lhr_pasangan && validationNom.errors.tempat_lhr_pasangan ? true : false}
                />
                {validationNom.touched.tempat_lhr_pasangan && validationNom.errors.tempat_lhr_pasangan ? <FormFeedback type="invalid">{validationNom.errors.tempat_lhr_pasangan}</FormFeedback> : null}
              </div>
              <div className="mb-3 col-lg-3">
                <Label htmlFor="tanggal_lhr_pasangan-field" className="form-label">
                  Tanggal Lahir Pasangan
                </Label>
                <Flatpickr
                  className="form-control"
                  id="datepicker-tanggal_lhr_pasangan-input"
                  placeholder="Pilih Tanggal Lahir Pasangan"
                  options={{
                    mode: "single",
                    dateFormat: "Y/m/d",
                  }}
                  onChange={(selectedDates, dateStr) => {
                    validationNom.setFieldValue("tanggal_lhr_pasangan", dateStr);
                    validationNom.setFieldValue("usia", moment().diff(moment(dateStr, "YYYY/MM/DD"), "years"));
                  }}
                  value={validationNom.values.tanggal_lhr_pasangan}
                />
                {validationNom.touched.tanggal_lhr_pasangan && validationNom.errors.tanggal_lhr_pasangan ? (
                  <p className="text-danger" type="invalid">
                    {validationNom.errors.tanggal_lhr_pasangan}
                  </p>
                ) : null}
              </div>
              <div className="mb-3 col-lg-3">
                <Label htmlFor="pekerjaan_pasangan-field" className="form-label">
                  Pekerjaan
                </Label>
                <Input
                  name="pekerjaan_pasangan"
                  id="pekerjaan_pasangan-field"
                  className="form-control"
                  placeholder="Isi Pekerjaan Pasangan"
                  type="text"
                  onChange={(e) => {
                    const val = e.target.value;
                    validationNom.setFieldValue("pekerjaan_pasangan", val);
                  }}
                  value={validationNom.values.pekerjaan_pasangan}
                  invalid={validationNom.touched.pekerjaan_pasangan && validationNom.errors.pekerjaan_pasangan ? true : false}
                />
                {validationNom.touched.pekerjaan_pasangan && validationNom.errors.pekerjaan_pasangan ? <FormFeedback type="invalid">{validationNom.errors.pekerjaan_pasangan}</FormFeedback> : null}
              </div>
              <div className="mb-3 col-lg-3">
                <Label htmlFor="alamat_pasangan-field" className="form-label">
                  Alamat Pasangan
                </Label>
                <Input
                  name="alamat_pasangan"
                  id="alamat_pasangan-field"
                  className="form-control"
                  placeholder="Isi Alamat Pasangan"
                  type="text"
                  onChange={(e) => {
                    const val = e.target.value;
                    validationNom.setFieldValue("alamat_pasangan", val);
                  }}
                  value={validationNom.values.alamat_pasangan}
                  invalid={validationNom.touched.alamat_pasangan && validationNom.errors.alamat_pasangan ? true : false}
                />
                {validationNom.touched.alamat_pasangan && validationNom.errors.alamat_pasangan ? <FormFeedback type="invalid">{validationNom.errors.alamat_pasangan}</FormFeedback> : null}
              </div>
              <div className="mb-3 col-lg-3">
                <Label htmlFor="ktp_pasangan-field" className="form-label">
                  Ktp Pasangan
                </Label>
                <Input
                  name="ktp_pasangan"
                  id="ktp_pasangan-field"
                  className="form-control"
                  placeholder="Isi Ktp Pasangan"
                  type="text"
                  onChange={(e) => {
                    const val = e.target.value;
                    validationNom.setFieldValue("ktp_pasangan", val);
                  }}
                  value={validationNom.values.ktp_pasangan}
                  invalid={validationNom.touched.ktp_pasangan && validationNom.errors.ktp_pasangan ? true : false}
                />
                {validationNom.touched.ktp_pasangan && validationNom.errors.ktp_pasangan ? <FormFeedback type="invalid">{validationNom.errors.ktp_pasangan}</FormFeedback> : null}
              </div>
            </div>
            <div className="row border-bottom mb-1 pb-2">
              <h5 className="mb-3 bg-soft-info p-2 pb-3">Data Tanah dan Lokasi Tanah</h5>
              <div className="mb-3 col-lg-3">
                <Label htmlFor="luas_tanah-field" className="form-label">
                  Luas Tanah
                </Label>
                <Input
                  name="luas_tanah"
                  id="luas_tanah-field"
                  className="form-control"
                  placeholder="Isi Luas Tanah"
                  type="text"
                  onChange={(e) => {
                    validationNom.setFieldValue("luas_tanah", e.target.value);
                    validationNom.setFieldValue("terbilang_luas_tanah", numberToWordOnly(parseFloat(e.target.value), "Meter Persegi"));

                    if (validationNom.values.njop) {
                      const harga = parseFloat(e.target.value) * parseFloat(validationNom.values.njop);
                      validationNom.setFieldValue("harga", harga);
                      validationNom.setFieldValue("terbilang_harga", numberToWords(parseFloat(harga), "Rupiah"));
                    }
                  }}
                  value={validationNom.values.luas_tanah}
                  invalid={validationNom.touched.luas_tanah && validationNom.errors.luas_tanah ? true : false}
                />
                {validationNom.touched.luas_tanah && validationNom.errors.luas_tanah && <FormFeedback type="invalid">{validationNom.errors.luas_tanah}</FormFeedback>}
              </div>

              <div className="mb-3 col-lg-3">
                <Label htmlFor="kelas_desa-field" className="form-label">
                  Kelas Desa
                </Label>
                <Input
                  name="kelas_desa"
                  id="kelas_desa-field"
                  className="form-control"
                  placeholder="Isi Kelas Desa"
                  type="text"
                  onChange={(e) => {
                    validationNom.setFieldValue("kelas_desa", e.target.value);
                  }}
                  value={validationNom.values.kelas_desa}
                  invalid={validationNom.touched.kelas_desa && validationNom.errors.kelas_desa ? true : false}
                />
                {validationNom.touched.kelas_desa && validationNom.errors.kelas_desa && <FormFeedback type="invalid">{validationNom.errors.kelas_desa}</FormFeedback>}
              </div>

              <div className="mb-3 col-lg-3">
                <Label htmlFor="terbilang_luas_tanah-field" className="form-label">
                  Terbilang Luas Tanah
                </Label>
                <Input
                  name="terbilang_luas_tanah"
                  id="terbilang_luas_tanah-field"
                  className="form-control"
                  placeholder="Terbilang Luas Tanah"
                  type="text"
                  onChange={(e) => {
                    validationNom.setFieldValue("terbilang_luas_tanah", e.target.value);
                  }}
                  value={validationNom.values.terbilang_luas_tanah}
                  invalid={validationNom.touched.terbilang_luas_tanah && validationNom.errors.terbilang_luas_tanah ? true : false}
                />
                {validationNom.touched.terbilang_luas_tanah && validationNom.errors.terbilang_luas_tanah && <FormFeedback type="invalid">{validationNom.errors.terbilang_luas_tanah}</FormFeedback>}
              </div>

              <div className="mb-3 col-lg-3">
                <Label htmlFor="no_c-field" className="form-label">
                  No C
                </Label>
                <Input
                  name="no_c"
                  id="no_c-field"
                  className="form-control"
                  placeholder="Isi No C"
                  type="text"
                  onChange={(e) => {
                    validationNom.setFieldValue("no_c", e.target.value);
                  }}
                  value={validationNom.values.no_c}
                  invalid={validationNom.touched.no_c && validationNom.errors.no_c ? true : false}
                />
                {validationNom.touched.no_c && validationNom.errors.no_c && <FormFeedback type="invalid">{validationNom.errors.no_c}</FormFeedback>}
              </div>

              <div className="mb-3 col-lg-3">
                <Label htmlFor="no_persil-field" className="form-label">
                  No Persil
                </Label>
                <Input
                  name="no_persil"
                  id="no_persil-field"
                  className="form-control"
                  placeholder="Isi No Persil"
                  type="text"
                  onChange={(e) => {
                    validationNom.setFieldValue("no_persil", e.target.value);
                  }}
                  value={validationNom.values.no_persil}
                  invalid={validationNom.touched.no_persil && validationNom.errors.no_persil ? true : false}
                />
                {validationNom.touched.no_persil && validationNom.errors.no_persil && <FormFeedback type="invalid">{validationNom.errors.no_persil}</FormFeedback>}
              </div>

              <div className="mb-3 col-lg-3">
                <Label htmlFor="blok-field" className="form-label">
                  Blok
                </Label>
                <Input
                  name="blok"
                  id="blok-field"
                  className="form-control"
                  placeholder="Isi Blok"
                  type="text"
                  onChange={(e) => {
                    validationNom.setFieldValue("blok", e.target.value);
                  }}
                  value={validationNom.values.blok}
                  invalid={validationNom.touched.blok && validationNom.errors.blok ? true : false}
                />
                {validationNom.touched.blok && validationNom.errors.blok && <FormFeedback type="invalid">{validationNom.errors.blok}</FormFeedback>}
              </div>

              <div className="mb-3 col-lg-3">
                <Label htmlFor="nop-field" className="form-label">
                  NOP
                </Label>
                <Input
                  name="nop"
                  id="nop-field"
                  className="form-control"
                  placeholder="Isi NOP"
                  type="text"
                  onChange={(e) => {
                    validationNom.setFieldValue("nop", e.target.value);
                  }}
                  value={validationNom.values.nop}
                  invalid={validationNom.touched.nop && validationNom.errors.nop ? true : false}
                />
                {validationNom.touched.nop && validationNom.errors.nop && <FormFeedback type="invalid">{validationNom.errors.nop}</FormFeedback>}
              </div>

              <div className="mb-3 col-lg-3">
                <Label htmlFor="njop-field" className="form-label">
                  NJOP
                </Label>
                <Input
                  name="njop"
                  id="njop-field"
                  className="form-control"
                  placeholder="Isi NJOP"
                  type="text"
                  onChange={(e) => {
                    validationNom.setFieldValue("njop", e.target.value);
                    const harga = parseFloat(validationNom.values.luas_tanah) * parseFloat(e.target.value);
                    validationNom.setFieldValue("harga", harga);
                    validationNom.setFieldValue("terbilang_harga", numberToWords(parseFloat(harga), "Rupiah"));
                  }}
                  value={validationNom.values.njop}
                  invalid={validationNom.touched.njop && validationNom.errors.njop ? true : false}
                />
                {validationNom.touched.njop && validationNom.errors.njop && <FormFeedback type="invalid">{validationNom.errors.njop}</FormFeedback>}
              </div>

              <div className="mb-3 col-lg-3">
                <Label htmlFor="harga-field" className="form-label">
                  Harga
                </Label>
                <Input
                  name="harga"
                  id="harga-field"
                  className="form-control"
                  placeholder="Harga"
                  type="text"
                  onChange={(e) => {
                    validationNom.setFieldValue("harga", e.target.value);
                  }}
                  value={validationNom.values.harga}
                  invalid={validationNom.touched.harga && validationNom.errors.harga ? true : false}
                />
                {validationNom.touched.harga && validationNom.errors.harga && <FormFeedback type="invalid">{validationNom.errors.harga}</FormFeedback>}
              </div>

              <div className="mb-3 col-lg-3">
                <Label htmlFor="terbilang_harga-field" className="form-label">
                  Terbilang Harga
                </Label>
                <Input
                  name="terbilang_harga"
                  id="terbilang_harga-field"
                  className="form-control"
                  placeholder="Terbilang Harga"
                  type="text"
                  onChange={(e) => {
                    validationNom.setFieldValue("terbilang_harga", e.target.value);
                  }}
                  value={validationNom.values.terbilang_harga}
                  invalid={validationNom.touched.terbilang_harga && validationNom.errors.terbilang_harga ? true : false}
                />
                {validationNom.touched.terbilang_harga && validationNom.errors.terbilang_harga && <FormFeedback type="invalid">{validationNom.errors.terbilang_harga}</FormFeedback>}
              </div>

              <div className="mb-3 col-lg-3">
                <Label htmlFor="letak_tanah-field" className="form-label">
                  Letak Tanah
                </Label>
                <Input
                  name="letak_tanah"
                  id="letak_tanah-field"
                  className="form-control"
                  placeholder="Letak Tanah"
                  type="text"
                  onChange={(e) => {
                    validationNom.setFieldValue("letak_tanah", e.target.value);
                  }}
                  value={validationNom.values.letak_tanah}
                  invalid={validationNom.touched.letak_tanah && validationNom.errors.letak_tanah ? true : false}
                />
                {validationNom.touched.letak_tanah && validationNom.errors.letak_tanah && <FormFeedback type="invalid">{validationNom.errors.letak_tanah}</FormFeedback>}
              </div>

              <div className="mb-3 col-lg-3">
                <Label htmlFor="desa-field" className="form-label">
                  Desa
                </Label>
                <Input
                  name="desa"
                  id="desa-field"
                  className="form-control"
                  placeholder="Desa"
                  type="text"
                  onChange={(e) => {
                    validationNom.setFieldValue("desa", e.target.value);
                  }}
                  value={validationNom.values.desa}
                  invalid={validationNom.touched.desa && validationNom.errors.desa ? true : false}
                />
                {validationNom.touched.desa && validationNom.errors.desa && <FormFeedback type="invalid">{validationNom.errors.desa}</FormFeedback>}
              </div>

              <div className="mb-3 col-lg-3">
                <Label htmlFor="kecamatan-field" className="form-label">
                  Kecamatan
                </Label>
                <Input
                  name="kecamatan"
                  id="kecamatan-field"
                  className="form-control"
                  placeholder="Kecamatan"
                  type="text"
                  onChange={(e) => {
                    validationNom.setFieldValue("kecamatan", e.target.value);
                  }}
                  value={validationNom.values.kecamatan}
                  invalid={validationNom.touched.kecamatan && validationNom.errors.kecamatan ? true : false}
                />
                {validationNom.touched.kecamatan && validationNom.errors.kecamatan && <FormFeedback type="invalid">{validationNom.errors.kecamatan}</FormFeedback>}
              </div>
              <div className="mb-3 col-lg-3">
                <Label htmlFor="tempat-field" className="form-label">
                  Tempat
                </Label>
                <Input
                  name="tempat"
                  id="tempat-field"
                  className="form-control"
                  placeholder="Tempat"
                  type="text"
                  onChange={(e) => {
                    validationNom.setFieldValue("tempat", e.target.value);
                  }}
                  value={validationNom.values.tempat}
                  invalid={validationNom.touched.tempat && validationNom.errors.tempat ? true : false}
                />
                {validationNom.touched.tempat && validationNom.errors.tempat && <FormFeedback type="invalid">{validationNom.errors.tempat}</FormFeedback>}
              </div>

              <div className="mb-3 col-lg-3">
                <Label htmlFor="tgl-field" className="form-label">
                  Tanggal
                </Label>
                <Flatpickr
                  className="form-control"
                  id="datepicker-tgl-input"
                  placeholder="Tanggal"
                  options={{
                    mode: "single",
                    dateFormat: "Y/m/d",
                  }}
                  onChange={(selectedDates, dateStr) => {
                    validationNom.setFieldValue("tgl", dateStr);
                  }}
                  value={validationNom.values.tgl}
                />
                {validationNom.touched.tgl && validationNom.errors.tgl ? (
                  <p className="text-danger" type="invalid">
                    {validationNom.errors.tgl}
                  </p>
                ) : null}
              </div>

              <div className="mb-3 col-lg-3">
                <Label htmlFor="rt-field" className="form-label">
                  RT
                </Label>
                <Input
                  name="rt"
                  id="rt-field"
                  className="form-control"
                  placeholder="Isi Nomor RT"
                  type="text"
                  onChange={(e) => {
                    validationNom.setFieldValue("rt", e.target.value);
                  }}
                  value={validationNom.values.rt}
                  invalid={validationNom.touched.rt && validationNom.errors.rt ? true : false}
                />
                {validationNom.touched.rt && validationNom.errors.rt && <FormFeedback type="invalid">{validationNom.errors.rt}</FormFeedback>}
              </div>

              <div className="mb-3 col-lg-3">
                <Label htmlFor="rw-field" className="form-label">
                  RW
                </Label>
                <Input
                  name="rw"
                  id="rw-field"
                  className="form-control"
                  placeholder="Isi Nomor RW"
                  type="text"
                  onChange={(e) => {
                    validationNom.setFieldValue("rw", e.target.value);
                  }}
                  value={validationNom.values.rw}
                  invalid={validationNom.touched.rw && validationNom.errors.rw ? true : false}
                />
                {validationNom.touched.rw && validationNom.errors.rw && <FormFeedback type="invalid">{validationNom.errors.rw}</FormFeedback>}
              </div>

              <div className="mb-3 col-lg-3">
                <Label htmlFor="ketua_rt-field" className="form-label">
                  Ketua RT
                </Label>
                <Input
                  name="ketua_rt"
                  id="ketua_rt-field"
                  className="form-control"
                  placeholder="Isi Nama Ketua RT"
                  type="text"
                  onChange={(e) => {
                    validationNom.setFieldValue("ketua_rt", e.target.value);
                  }}
                  value={validationNom.values.ketua_rt}
                  invalid={validationNom.touched.ketua_rt && validationNom.errors.ketua_rt ? true : false}
                />
                {validationNom.touched.ketua_rt && validationNom.errors.ketua_rt && <FormFeedback type="invalid">{validationNom.errors.ketua_rt}</FormFeedback>}
              </div>

              <div className="mb-3 col-lg-3">
                <Label htmlFor="ketua_rw-field" className="form-label">
                  Ketua RW
                </Label>
                <Input
                  name="ketua_rw"
                  id="ketua_rw-field"
                  className="form-control"
                  placeholder="Isi Nama Ketua RW"
                  type="text"
                  onChange={(e) => {
                    validationNom.setFieldValue("ketua_rw", e.target.value);
                  }}
                  value={validationNom.values.ketua_rw}
                  invalid={validationNom.touched.ketua_rw && validationNom.errors.ketua_rw ? true : false}
                />
                {validationNom.touched.ketua_rw && validationNom.errors.ketua_rw && <FormFeedback type="invalid">{validationNom.errors.ketua_rw}</FormFeedback>}
              </div>

              <div className="mb-3 col-lg-3">
                <Label htmlFor="kadus-field" className="form-label">
                  Kadus
                </Label>
                <Input
                  name="kadus"
                  id="kadus-field"
                  className="form-control"
                  placeholder="Kadus"
                  type="text"
                  onChange={(e) => {
                    validationNom.setFieldValue("kadus", e.target.value);
                  }}
                  value={validationNom.values.kadus}
                  invalid={validationNom.touched.kadus && validationNom.errors.kadus ? true : false}
                />
                {validationNom.touched.kadus && validationNom.errors.kadus && <FormFeedback type="invalid">{validationNom.errors.kadus}</FormFeedback>}
              </div>

              <div className="mb-3 col-lg-3">
                <Label htmlFor="sekdes-field" className="form-label">
                  Sekdes
                </Label>
                <Input
                  name="sekdes"
                  id="sekdes-field"
                  className="form-control"
                  placeholder="Isi Nama Sekdes"
                  type="text"
                  onChange={(e) => {
                    validationNom.setFieldValue("sekdes", e.target.value);
                  }}
                  value={validationNom.values.sekdes}
                  invalid={validationNom.touched.sekdes && validationNom.errors.sekdes ? true : false}
                />
                {validationNom.touched.sekdes && validationNom.errors.sekdes && <FormFeedback type="invalid">{validationNom.errors.sekdes}</FormFeedback>}
              </div>

              <div className="mb-3 col-lg-3">
                <Label htmlFor="kepala_desa-field" className="form-label">
                  Kepala Desa
                </Label>
                <Input
                  name="kepala_desa"
                  id="kepala_desa-field"
                  className="form-control"
                  placeholder="Kepala Desa"
                  type="text"
                  onChange={(e) => {
                    validationNom.setFieldValue("kepala_desa", e.target.value);
                  }}
                  value={validationNom.values.kepala_desa}
                  invalid={validationNom.touched.kepala_desa && validationNom.errors.kepala_desa ? true : false}
                />
                {validationNom.touched.kepala_desa && validationNom.errors.kepala_desa && <FormFeedback type="invalid">{validationNom.errors.kepala_desa}</FormFeedback>}
              </div>

              <div className="mb-3 col-lg-3">
                <Label htmlFor="utara-field" className="form-label">
                  Batas Utara
                </Label>
                <Input
                  name="utara"
                  id="utara-field"
                  className="form-control"
                  placeholder="Isi Batas Utara"
                  type="text"
                  onChange={(e) => {
                    validationNom.setFieldValue("utara", e.target.value);
                  }}
                  value={validationNom.values.utara}
                  invalid={validationNom.touched.utara && validationNom.errors.utara ? true : false}
                />
                {validationNom.touched.utara && validationNom.errors.utara && <FormFeedback type="invalid">{validationNom.errors.utara}</FormFeedback>}
              </div>

              <div className="mb-3 col-lg-3">
                <Label htmlFor="timur-field" className="form-label">
                  Batas Timur
                </Label>
                <Input
                  name="timur"
                  id="timur-field"
                  className="form-control"
                  placeholder="Isi Batas Timur"
                  type="text"
                  onChange={(e) => {
                    validationNom.setFieldValue("timur", e.target.value);
                  }}
                  value={validationNom.values.timur}
                  invalid={validationNom.touched.timur && validationNom.errors.timur ? true : false}
                />
                {validationNom.touched.timur && validationNom.errors.timur && <FormFeedback type="invalid">{validationNom.errors.timur}</FormFeedback>}
              </div>

              <div className="mb-3 col-lg-3">
                <Label htmlFor="selatan-field" className="form-label">
                  Batas Selatan
                </Label>
                <Input
                  name="selatan"
                  id="selatan-field"
                  className="form-control"
                  placeholder="Isi Batas Selatan"
                  type="text"
                  onChange={(e) => {
                    validationNom.setFieldValue("selatan", e.target.value);
                  }}
                  value={validationNom.values.selatan}
                  invalid={validationNom.touched.selatan && validationNom.errors.selatan ? true : false}
                />
                {validationNom.touched.selatan && validationNom.errors.selatan && <FormFeedback type="invalid">{validationNom.errors.selatan}</FormFeedback>}
              </div>

              <div className="mb-3 col-lg-3">
                <Label htmlFor="barat-field" className="form-label">
                  Batas Barat
                </Label>
                <Input
                  name="barat"
                  id="barat-field"
                  className="form-control"
                  placeholder="Batas Barat"
                  type="text"
                  onChange={(e) => {
                    validationNom.setFieldValue("barat", e.target.value);
                  }}
                  value={validationNom.values.barat}
                  invalid={validationNom.touched.barat && validationNom.errors.barat ? true : false}
                />
                {validationNom.touched.barat && validationNom.errors.barat && <FormFeedback type="invalid">{validationNom.errors.barat}</FormFeedback>}
              </div>
            </div>
            <div className="row">
              <h5 className="mb-3 bg-soft-info p-2 pb-3">Riwayat Tanah</h5>
              <div className="mb-3 col-lg-3">
                <Label htmlFor="tahun_1-field" className="form-label">
                  Tahun 1
                </Label>
                <Input
                  name="tahun_1"
                  id="tahun_1-field"
                  className="form-control"
                  placeholder="Tahun 1"
                  type="text"
                  onChange={(e) => {
                    validationNom.setFieldValue("tahun_1", e.target.value);
                  }}
                  value={validationNom.values.tahun_1}
                  invalid={validationNom.touched.tahun_1 && validationNom.errors.tahun_1 ? true : false}
                />
                {validationNom.touched.tahun_1 && validationNom.errors.tahun_1 && <FormFeedback type="invalid">{validationNom.errors.tahun_1}</FormFeedback>}
              </div>

              <div className="mb-3 col-lg-3">
                <Label htmlFor="ats_nama_1-field" className="form-label">
                  Atas Nama 1
                </Label>
                <Input
                  name="ats_nama_1"
                  id="ats_nama_1-field"
                  className="form-control"
                  placeholder="Atas Nama 1"
                  type="text"
                  onChange={(e) => {
                    validationNom.setFieldValue("ats_nama_1", e.target.value);
                  }}
                  value={validationNom.values.ats_nama_1}
                  invalid={validationNom.touched.ats_nama_1 && validationNom.errors.ats_nama_1 ? true : false}
                />
                {validationNom.touched.ats_nama_1 && validationNom.errors.ats_nama_1 && <FormFeedback type="invalid">{validationNom.errors.ats_nama_1}</FormFeedback>}
              </div>

              <div className="mb-3 col-lg-3">
                <Label htmlFor="kota_1-field" className="form-label">
                  Kota 1
                </Label>
                <Input
                  name="kota_1"
                  id="kota_1-field"
                  className="form-control"
                  placeholder="Kota 1"
                  type="text"
                  onChange={(e) => {
                    validationNom.setFieldValue("kota_1", e.target.value);
                  }}
                  value={validationNom.values.kota_1}
                  invalid={validationNom.touched.kota_1 && validationNom.errors.kota_1 ? true : false}
                />
                {validationNom.touched.kota_1 && validationNom.errors.kota_1 && <FormFeedback type="invalid">{validationNom.errors.kota_1}</FormFeedback>}
              </div>
              <div className="mb-3 col-lg-3">
                <Label htmlFor="berdasarkan_1-field" className="form-label">
                  Berdasarkan 1
                </Label>
                <Input
                  name="berdasarkan_1"
                  id="berdasarkan_1-field"
                  className="form-control"
                  placeholder="Berdasarkan 1"
                  type="text"
                  onChange={(e) => {
                    validationNom.setFieldValue("berdasarkan_1", e.target.value);
                  }}
                  value={validationNom.values.berdasarkan_1}
                  invalid={validationNom.touched.berdasarkan_1 && validationNom.errors.berdasarkan_1 ? true : false}
                />
                {validationNom.touched.berdasarkan_1 && validationNom.errors.berdasarkan_1 && <FormFeedback type="invalid">{validationNom.errors.berdasarkan_1}</FormFeedback>}
              </div>
            </div>
            <div className="row">
              <div className="mb-3 col-lg-3">
                <Label htmlFor="tahun_2-field" className="form-label">
                  Tahun 2
                </Label>
                <Input
                  name="tahun_2"
                  id="tahun_2-field"
                  className="form-control"
                  placeholder="Tahun 2"
                  type="text"
                  onChange={(e) => {
                    validationNom.setFieldValue("tahun_2", e.target.value);
                  }}
                  value={validationNom.values.tahun_2}
                  invalid={validationNom.touched.tahun_2 && validationNom.errors.tahun_2 ? true : false}
                />
                {validationNom.touched.tahun_2 && validationNom.errors.tahun_2 && <FormFeedback type="invalid">{validationNom.errors.tahun_2}</FormFeedback>}
              </div>

              <div className="mb-3 col-lg-3">
                <Label htmlFor="beralih_kepada_2-field" className="form-label">
                  Beralih Kepada 2
                </Label>
                <Input
                  name="beralih_kepada_2"
                  id="beralih_kepada_2-field"
                  className="form-control"
                  placeholder="Beralih Kepada 2"
                  type="text"
                  onChange={(e) => {
                    validationNom.setFieldValue("beralih_kepada_2", e.target.value);
                  }}
                  value={validationNom.values.beralih_kepada_2}
                  invalid={validationNom.touched.beralih_kepada_2 && validationNom.errors.beralih_kepada_2 ? true : false}
                />
                {validationNom.touched.beralih_kepada_2 && validationNom.errors.beralih_kepada_2 && <FormFeedback type="invalid">{validationNom.errors.beralih_kepada_2}</FormFeedback>}
              </div>

              <div className="mb-3 col-lg-3">
                <Label htmlFor="kota_2-field" className="form-label">
                  Kota 2
                </Label>
                <Input
                  name="kota_2"
                  id="kota_2-field"
                  className="form-control"
                  placeholder="Kota 2"
                  type="text"
                  onChange={(e) => {
                    validationNom.setFieldValue("kota_2", e.target.value);
                  }}
                  value={validationNom.values.kota_2}
                  invalid={validationNom.touched.kota_2 && validationNom.errors.kota_2 ? true : false}
                />
                {validationNom.touched.kota_2 && validationNom.errors.kota_2 && <FormFeedback type="invalid">{validationNom.errors.kota_2}</FormFeedback>}
              </div>

              <div className="mb-3 col-lg-3">
                <Label htmlFor="berdasarkan_2-field" className="form-label">
                  Berdasarkan 2
                </Label>
                <Input
                  name="berdasarkan_2"
                  id="berdasarkan_2-field"
                  className="form-control"
                  placeholder="Berdasarkan 2"
                  type="text"
                  onChange={(e) => {
                    validationNom.setFieldValue("berdasarkan_2", e.target.value);
                  }}
                  value={validationNom.values.berdasarkan_2}
                  invalid={validationNom.touched.berdasarkan_2 && validationNom.errors.berdasarkan_2 ? true : false}
                />
                {validationNom.touched.berdasarkan_2 && validationNom.errors.berdasarkan_2 && <FormFeedback type="invalid">{validationNom.errors.berdasarkan_2}</FormFeedback>}
              </div>
            </div>
            <div className="row">
              <div className="mb-3 col-lg-3">
                <Label htmlFor="tahun_3-field" className="form-label">
                  Tahun 3
                </Label>
                <Input
                  name="tahun_3"
                  id="tahun_3-field"
                  className="form-control"
                  placeholder="Tahun 3"
                  type="text"
                  onChange={(e) => {
                    validationNom.setFieldValue("tahun_3", e.target.value);
                  }}
                  value={validationNom.values.tahun_3}
                  invalid={validationNom.touched.tahun_3 && validationNom.errors.tahun_3 ? true : false}
                />
                {validationNom.touched.tahun_3 && validationNom.errors.tahun_3 && <FormFeedback type="invalid">{validationNom.errors.tahun_3}</FormFeedback>}
              </div>

              <div className="mb-3 col-lg-3">
                <Label htmlFor="beralih_kepada_3-field" className="form-label">
                  Beralih Kepada 3
                </Label>
                <Input
                  name="beralih_kepada_3"
                  id="beralih_kepada_3-field"
                  className="form-control"
                  placeholder="Beralih Kepada 3"
                  type="text"
                  onChange={(e) => {
                    validationNom.setFieldValue("beralih_kepada_3", e.target.value);
                  }}
                  value={validationNom.values.beralih_kepada_3}
                  invalid={validationNom.touched.beralih_kepada_3 && validationNom.errors.beralih_kepada_3 ? true : false}
                />
                {validationNom.touched.beralih_kepada_3 && validationNom.errors.beralih_kepada_3 && <FormFeedback type="invalid">{validationNom.errors.beralih_kepada_3}</FormFeedback>}
              </div>

              <div className="mb-3 col-lg-3">
                <Label htmlFor="kota_3-field" className="form-label">
                  Kota 3
                </Label>
                <Input
                  name="kota_3"
                  id="kota_3-field"
                  className="form-control"
                  placeholder="Kota 3"
                  type="text"
                  onChange={(e) => {
                    validationNom.setFieldValue("kota_3", e.target.value);
                  }}
                  value={validationNom.values.kota_3}
                  invalid={validationNom.touched.kota_3 && validationNom.errors.kota_3 ? true : false}
                />
                {validationNom.touched.kota_3 && validationNom.errors.kota_3 && <FormFeedback type="invalid">{validationNom.errors.kota_3}</FormFeedback>}
              </div>

              <div className="mb-3 col-lg-3">
                <Label htmlFor="berdasarkan_3-field" className="form-label">
                  Berdasarkan 3
                </Label>
                <Input
                  name="berdasarkan_3"
                  id="berdasarkan_3-field"
                  className="form-control"
                  placeholder="Berdasarkan 3"
                  type="text"
                  onChange={(e) => {
                    validationNom.setFieldValue("berdasarkan_3", e.target.value);
                  }}
                  value={validationNom.values.berdasarkan_3}
                  invalid={validationNom.touched.berdasarkan_3 && validationNom.errors.berdasarkan_3 ? true : false}
                />
                {validationNom.touched.berdasarkan_3 && validationNom.errors.berdasarkan_3 && <FormFeedback type="invalid">{validationNom.errors.berdasarkan_3}</FormFeedback>}
              </div>
            </div>
            <div className="row border-bottom mb-1 pb-2">
              <div className="mb-3 col-lg-3">
                <Label htmlFor="tahun_4-field" className="form-label">
                  Tahun 4
                </Label>
                <Input
                  name="tahun_4"
                  id="tahun_4-field"
                  className="form-control"
                  placeholder="Tahun 4"
                  type="text"
                  onChange={(e) => {
                    validationNom.setFieldValue("tahun_4", e.target.value);
                  }}
                  value={validationNom.values.tahun_4}
                  invalid={validationNom.touched.tahun_4 && validationNom.errors.tahun_4 ? true : false}
                />
                {validationNom.touched.tahun_4 && validationNom.errors.tahun_4 && <FormFeedback type="invalid">{validationNom.errors.tahun_4}</FormFeedback>}
              </div>

              <div className="mb-3 col-lg-3">
                <Label htmlFor="beralih_kepada_4-field" className="form-label">
                  Beralih Kepada 4
                </Label>
                <Input
                  name="beralih_kepada_4"
                  id="beralih_kepada_4-field"
                  className="form-control"
                  placeholder="Beralih Kepada 4"
                  type="text"
                  onChange={(e) => {
                    validationNom.setFieldValue("beralih_kepada_4", e.target.value);
                  }}
                  value={validationNom.values.beralih_kepada_4}
                  invalid={validationNom.touched.beralih_kepada_4 && validationNom.errors.beralih_kepada_4 ? true : false}
                />
                {validationNom.touched.beralih_kepada_4 && validationNom.errors.beralih_kepada_4 && <FormFeedback type="invalid">{validationNom.errors.beralih_kepada_4}</FormFeedback>}
              </div>

              <div className="mb-3 col-lg-3">
                <Label htmlFor="kota_4-field" className="form-label">
                  Kota 4
                </Label>
                <Input
                  name="kota_4"
                  id="kota_4-field"
                  className="form-control"
                  placeholder="Kota 4"
                  type="text"
                  onChange={(e) => {
                    validationNom.setFieldValue("kota_4", e.target.value);
                  }}
                  value={validationNom.values.kota_4}
                  invalid={validationNom.touched.kota_4 && validationNom.errors.kota_4 ? true : false}
                />
                {validationNom.touched.kota_4 && validationNom.errors.kota_4 && <FormFeedback type="invalid">{validationNom.errors.kota_4}</FormFeedback>}
              </div>

              <div className="mb-3 col-lg-3">
                <Label htmlFor="berdasarkan_4-field" className="form-label">
                  Berdasarkan 4
                </Label>
                <Input
                  name="berdasarkan_4"
                  id="berdasarkan_4-field"
                  className="form-control"
                  placeholder="Berdasarkan 4"
                  type="text"
                  onChange={(e) => {
                    validationNom.setFieldValue("berdasarkan_4", e.target.value);
                  }}
                  value={validationNom.values.berdasarkan_4}
                  invalid={validationNom.touched.berdasarkan_4 && validationNom.errors.berdasarkan_4 ? true : false}
                />
                {validationNom.touched.berdasarkan_4 && validationNom.errors.berdasarkan_4 && <FormFeedback type="invalid">{validationNom.errors.berdasarkan_4}</FormFeedback>}
              </div>
            </div>
            <div className="row border-bottom mb-1 pb-2">
              <h5 className="mb-3 bg-soft-info p-2 pb-3">Saksi Saksi</h5>
              <div className="mb-3 col-lg-3">
                <Label htmlFor="saksi_sk_1-field" className="form-label">
                  Saksi SK 1 / RT
                </Label>
                <Input
                  name="saksi_sk_1"
                  id="saksi_sk_1-field"
                  className="form-control"
                  placeholder="Isi Saksi SK 1"
                  type="text"
                  onChange={(e) => {
                    validationNom.setFieldValue("saksi_sk_1", e.target.value);
                  }}
                  value={validationNom.values.saksi_sk_1}
                  invalid={validationNom.touched.saksi_sk_1 && validationNom.errors.saksi_sk_1 ? true : false}
                />
                {validationNom.touched.saksi_sk_1 && validationNom.errors.saksi_sk_1 && <FormFeedback type="invalid">{validationNom.errors.saksi_sk_1}</FormFeedback>}
              </div>

              <div className="mb-3 col-lg-3">
                <Label htmlFor="umur_sk_1-field" className="form-label">
                  Umur SK 1 / RT
                </Label>
                <Input
                  name="umur_sk_1"
                  id="umur_sk_1-field"
                  className="form-control"
                  placeholder="Isi Umur SK 1"
                  type="text"
                  onChange={(e) => {
                    validationNom.setFieldValue("umur_sk_1", e.target.value);
                  }}
                  value={validationNom.values.umur_sk_1}
                  invalid={validationNom.touched.umur_sk_1 && validationNom.errors.umur_sk_1 ? true : false}
                />
                {validationNom.touched.umur_sk_1 && validationNom.errors.umur_sk_1 && <FormFeedback type="invalid">{validationNom.errors.umur_sk_1}</FormFeedback>}
              </div>

              <div className="mb-3 col-lg-3">
                <Label htmlFor="pekerjaan_sk_1-field" className="form-label">
                  Pekerjaan SK 1 / RT
                </Label>
                <Input
                  name="pekerjaan_sk_1"
                  id="pekerjaan_sk_1-field"
                  className="form-control"
                  placeholder="Isi  Pekerjaan SK 1"
                  type="text"
                  onChange={(e) => {
                    validationNom.setFieldValue("pekerjaan_sk_1", e.target.value);
                  }}
                  value={validationNom.values.pekerjaan_sk_1}
                  invalid={validationNom.touched.pekerjaan_sk_1 && validationNom.errors.pekerjaan_sk_1 ? true : false}
                />
                {validationNom.touched.pekerjaan_sk_1 && validationNom.errors.pekerjaan_sk_1 && <FormFeedback type="invalid">{validationNom.errors.pekerjaan_sk_1}</FormFeedback>}
              </div>

              <div className="mb-3 col-lg-3">
                <Label htmlFor="alamat_sk_1-field" className="form-label">
                  Alamat SK 1 / RT
                </Label>
                <Input
                  name="alamat_sk_1"
                  id="alamat_sk_1-field"
                  className="form-control"
                  placeholder="Isi Alamat SK 1"
                  type="text"
                  onChange={(e) => {
                    validationNom.setFieldValue("alamat_sk_1", e.target.value);
                  }}
                  value={validationNom.values.alamat_sk_1}
                  invalid={validationNom.touched.alamat_sk_1 && validationNom.errors.alamat_sk_1 ? true : false}
                />
                {validationNom.touched.alamat_sk_1 && validationNom.errors.alamat_sk_1 && <FormFeedback type="invalid">{validationNom.errors.alamat_sk_1}</FormFeedback>}
              </div>

              <div className="mb-3 col-lg-3">
                <Label htmlFor="saksi_sk_2-field" className="form-label">
                  Saksi SK 2 / SekDes
                </Label>
                <Input
                  name="saksi_sk_2"
                  id="saksi_sk_2-field"
                  className="form-control"
                  placeholder="Isi Saksi SK 2"
                  type="text"
                  onChange={(e) => {
                    validationNom.setFieldValue("saksi_sk_2", e.target.value);
                  }}
                  value={validationNom.values.saksi_sk_2}
                  invalid={validationNom.touched.saksi_sk_2 && validationNom.errors.saksi_sk_2 ? true : false}
                />
                {validationNom.touched.saksi_sk_2 && validationNom.errors.saksi_sk_2 && <FormFeedback type="invalid">{validationNom.errors.saksi_sk_2}</FormFeedback>}
              </div>

              <div className="mb-3 col-lg-3">
                <Label htmlFor="umur_sk_2-field" className="form-label">
                  Umur SK 2 / SekDes
                </Label>
                <Input
                  name="umur_sk_2"
                  id="umur_sk_2-field"
                  className="form-control"
                  placeholder="Isi Umur SK 2"
                  type="text"
                  onChange={(e) => {
                    validationNom.setFieldValue("umur_sk_2", e.target.value);
                  }}
                  value={validationNom.values.umur_sk_2}
                  invalid={validationNom.touched.umur_sk_2 && validationNom.errors.umur_sk_2 ? true : false}
                />
                {validationNom.touched.umur_sk_2 && validationNom.errors.umur_sk_2 && <FormFeedback type="invalid">{validationNom.errors.umur_sk_2}</FormFeedback>}
              </div>

              <div className="mb-3 col-lg-3">
                <Label htmlFor="pekerjaan_sk_2-field" className="form-label">
                  Pekerjaan SK 2 / Sekdes
                </Label>
                <Input
                  name="pekerjaan_sk_2"
                  id="pekerjaan_sk_2-field"
                  className="form-control"
                  placeholder="Isi Pekerjaan SK 2"
                  type="text"
                  onChange={(e) => {
                    validationNom.setFieldValue("pekerjaan_sk_2", e.target.value);
                  }}
                  value={validationNom.values.pekerjaan_sk_2}
                  invalid={validationNom.touched.pekerjaan_sk_2 && validationNom.errors.pekerjaan_sk_2 ? true : false}
                />
                {validationNom.touched.pekerjaan_sk_2 && validationNom.errors.pekerjaan_sk_2 && <FormFeedback type="invalid">{validationNom.errors.pekerjaan_sk_2}</FormFeedback>}
              </div>

              <div className="mb-3 col-lg-3">
                <Label htmlFor="alamat_sk_2-field" className="form-label">
                  Alamat SK 2 / Sekdes
                </Label>
                <Input
                  name="alamat_sk_2"
                  id="alamat_sk_2-field"
                  className="form-control"
                  placeholder="Isi Alamat SK 2"
                  type="text"
                  onChange={(e) => {
                    validationNom.setFieldValue("alamat_sk_2", e.target.value);
                  }}
                  value={validationNom.values.alamat_sk_2}
                  invalid={validationNom.touched.alamat_sk_2 && validationNom.errors.alamat_sk_2 ? true : false}
                />
                {validationNom.touched.alamat_sk_2 && validationNom.errors.alamat_sk_2 && <FormFeedback type="invalid">{validationNom.errors.alamat_sk_2}</FormFeedback>}
              </div>

              <div className="mb-3 col-lg-3">
                <Label htmlFor="nama_2-field" className="form-label">
                  Nama 2
                </Label>
                <Input
                  name="nama_2"
                  id="nama_2-field"
                  className="form-control"
                  placeholder="Isi Nama 2"
                  type="text"
                  onChange={(e) => {
                    validationNom.setFieldValue("nama_2", e.target.value);
                  }}
                  value={validationNom.values.nama_2}
                  invalid={validationNom.touched.nama_2 && validationNom.errors.nama_2 ? true : false}
                />
                {validationNom.touched.nama_2 && validationNom.errors.nama_2 && <FormFeedback type="invalid">{validationNom.errors.nama_2}</FormFeedback>}
              </div>

              <div className="mb-3 col-lg-3">
                <Label htmlFor="warga_negara-field" className="form-label">
                  Warga Negara
                </Label>
                <Input
                  name="warga_negara"
                  id="warga_negara-field"
                  className="form-control"
                  placeholder="Isi Warga Negara"
                  type="text"
                  onChange={(e) => {
                    validationNom.setFieldValue("warga_negara", e.target.value);
                  }}
                  value={validationNom.values.warga_negara}
                  invalid={validationNom.touched.warga_negara && validationNom.errors.warga_negara ? true : false}
                />
                {validationNom.touched.warga_negara && validationNom.errors.warga_negara && <FormFeedback type="invalid">{validationNom.errors.warga_negara}</FormFeedback>}
              </div>

              <div className="mb-3 col-lg-3">
                <Label htmlFor="alih_2-field" className="form-label">
                  Peralihan
                </Label>
                <Input
                  name="alih_2"
                  id="alih_2-field"
                  className="form-control"
                  placeholder="Isi Peralihan"
                  type="text"
                  onChange={(e) => {
                    validationNom.setFieldValue("alih_2", e.target.value);
                  }}
                  value={validationNom.values.alih_2}
                  invalid={validationNom.touched.alih_2 && validationNom.errors.alih_2 ? true : false}
                />
                {validationNom.touched.alih_2 && validationNom.errors.alih_2 && <FormFeedback type="invalid">{validationNom.errors.alih_2}</FormFeedback>}
              </div>

              <div className="mb-3 col-lg-3">
                <Label htmlFor="jenis-field" className="form-label">
                  Jenis (TANAH DARAT / SAWAH KERING)
                </Label>
                <Input
                  name="jenis"
                  id="jenis-field"
                  className="form-control"
                  placeholder="Isi Jenis"
                  type="text"
                  onChange={(e) => {
                    validationNom.setFieldValue("jenis", e.target.value);
                  }}
                  value={validationNom.values.jenis}
                  invalid={validationNom.touched.jenis && validationNom.errors.jenis ? true : false}
                />
                {validationNom.touched.jenis && validationNom.errors.jenis && <FormFeedback type="invalid">{validationNom.errors.jenis}</FormFeedback>}
              </div>

              <div className="mb-3 col-lg-3">
                <Label htmlFor="pekerjaan-field" className="form-label">
                  Jenis Blanko C
                </Label>
                <Select
                  name="blankoc"
                  value={validationNom.values.blankoc}
                  placeholder="Pilih Jenis Blanko C"
                  onChange={(e) => {
                    validationNom.setFieldValue("blankoc", e);
                  }}
                  options={blankocData}
                ></Select>
              </div>

              <div className="mb-3 col-lg-3">
                <Label htmlFor="dasar-field" className="form-label">
                  Dasar
                </Label>
                <Input
                  name="dasar"
                  id="dasar-field"
                  className="form-control"
                  placeholder="Isi Dasar"
                  type="text"
                  onChange={(e) => {
                    validationNom.setFieldValue("dasar", e.target.value);
                  }}
                  value={validationNom.values.dasar}
                  invalid={validationNom.touched.dasar && validationNom.errors.dasar ? true : false}
                />
                {validationNom.touched.dasar && validationNom.errors.dasar && <FormFeedback type="invalid">{validationNom.errors.dasar}</FormFeedback>}
              </div>

              <div className="mb-3 col-lg-3">
                <Label htmlFor="saksi_st_1-field" className="form-label">
                  Saksi Sertifikat 1
                </Label>
                <Input
                  name="saksi_st_1"
                  id="saksi_st_1-field"
                  className="form-control"
                  placeholder="Isi Saksi Sertifikat 1"
                  type="text"
                  onChange={(e) => {
                    validationNom.setFieldValue("saksi_st_1", e.target.value);
                  }}
                  value={validationNom.values.saksi_st_1}
                  invalid={validationNom.touched.saksi_st_1 && validationNom.errors.saksi_st_1 ? true : false}
                />
                {validationNom.touched.saksi_st_1 && validationNom.errors.saksi_st_1 && <FormFeedback type="invalid">{validationNom.errors.saksi_st_1}</FormFeedback>}
              </div>

              <div className="mb-3 col-lg-3">
                <Label htmlFor="usia_2-field" className="form-label">
                  Usia 2
                </Label>
                <Input
                  name="usia_2"
                  id="usia_2-field"
                  className="form-control"
                  placeholder="Usia 2"
                  type="text"
                  onChange={(e) => {
                    validationNom.setFieldValue("usia_2", e.target.value);
                  }}
                  value={validationNom.values.usia_2}
                  invalid={validationNom.touched.usia_2 && validationNom.errors.usia_2 ? true : false}
                />
                {validationNom.touched.usia_2 && validationNom.errors.usia_2 && <FormFeedback type="invalid">{validationNom.errors.usia_2}</FormFeedback>}
              </div>

              <div className="mb-3 col-lg-3">
                <Label htmlFor="pekerjaan_2-field" className="form-label">
                  Pekerjaan 2
                </Label>
                <Input
                  name="pekerjaan_2"
                  id="pekerjaan_2-field"
                  className="form-control"
                  placeholder="Pekerjaan 2"
                  type="text"
                  onChange={(e) => {
                    validationNom.setFieldValue("pekerjaan_2", e.target.value);
                  }}
                  value={validationNom.values.pekerjaan_2}
                  invalid={validationNom.touched.pekerjaan_2 && validationNom.errors.pekerjaan_2 ? true : false}
                />
                {validationNom.touched.pekerjaan_2 && validationNom.errors.pekerjaan_2 && <FormFeedback type="invalid">{validationNom.errors.pekerjaan_2}</FormFeedback>}
              </div>

              <div className="mb-3 col-lg-3">
                <Label htmlFor="alamat_2-field" className="form-label">
                  Alamat 2
                </Label>
                <Input
                  name="alamat_2"
                  id="alamat_2-field"
                  className="form-control"
                  placeholder="Alamat 2"
                  type="text"
                  onChange={(e) => {
                    validationNom.setFieldValue("alamat_2", e.target.value);
                  }}
                  value={validationNom.values.alamat_2}
                  invalid={validationNom.touched.alamat_2 && validationNom.errors.alamat_2 ? true : false}
                />
                {validationNom.touched.alamat_2 && validationNom.errors.alamat_2 && <FormFeedback type="invalid">{validationNom.errors.alamat_2}</FormFeedback>}
              </div>

              <div className="mb-3 col-lg-3">
                <Label htmlFor="no_sph-field" className="form-label">
                  No SPH
                </Label>
                <Input
                  name="no_sph"
                  id="no_sph-field"
                  className="form-control"
                  placeholder="No SPH"
                  type="text"
                  onChange={(e) => {
                    validationNom.setFieldValue("no_sph", e.target.value);
                  }}
                  value={validationNom.values.no_sph}
                  invalid={validationNom.touched.no_sph && validationNom.errors.no_sph ? true : false}
                />
                {validationNom.touched.no_sph && validationNom.errors.no_sph && <FormFeedback type="invalid">{validationNom.errors.no_sph}</FormFeedback>}
              </div>

              <div className="mb-3 col-lg-3">
                <Label htmlFor="no_ijin_lksi-field" className="form-label">
                  No Ijin Lokasi
                </Label>
                <Input
                  name="no_ijin_lksi"
                  id="no_ijin_lksi-field"
                  className="form-control"
                  placeholder="No Ijin Lokasi"
                  type="text"
                  onChange={(e) => {
                    validationNom.setFieldValue("no_ijin_lksi", e.target.value);
                  }}
                  value={validationNom.values.no_ijin_lksi}
                  invalid={validationNom.touched.no_ijin_lksi && validationNom.errors.no_ijin_lksi ? true : false}
                />
                {validationNom.touched.no_ijin_lksi && validationNom.errors.no_ijin_lksi && <FormFeedback type="invalid">{validationNom.errors.no_ijin_lksi}</FormFeedback>}
              </div>
            </div>
          </ModalBody>
          <div className="modal-footer">
            <div className="hstack gap-2 justify-content-end">
              <button
                type="button"
                className="btn btn-light"
                onClick={() => {
                  setModal(false);
                }}
              >
                Tutup
              </button>
              <button type="submit" className="btn btn-success">
                <span className="d-flex align-items-center">
                  <span className="flex-grow-1">{!!isEdit ? "Update" : "Tambah Nominatif"}</span>
                  {loadingAction && (
                    <Spinner size="sm" className="ms-2 flex-shrink-0" role="status">
                      Loading...
                    </Spinner>
                  )}
                </span>
              </button>
            </div>
          </div>
        </Form>
      </Modal>
    </div>
  );
};

export default Nominatif;
